import { useAppSelector } from '../../../state/redux.hooks';

import { selectMitarbeiterRole } from './authSlice';

export function useMitarbeiterRole() {
  return useAppSelector(selectMitarbeiterRole);
}
